import React from "react";
import SiteBanner from "../IndexPage/SiteBanner";
import queryString from 'query-string';
// import RegisterAdvisor from "../IndexPage/RegisterAdvisor";

const Index = () => {
  return (
    <>
      <SiteBanner />
      {/* <RegisterAdvisor /> */}
    </>
  );
};

export default Index;
